// logo blockid
import KHCN_LOGO from "assets/images/logo/khcn-logo.png";
// logo tresemi
import TRESEMI_LOGO from "assets/images/logo/tresemi-logo.png";

// logo vbc
import VBC_LOGO from "assets/images/logo/vbc-logo.png";
import VBC_LOGO_DARK from "assets/images/logo/vbc-logo-dark.png";

import BCT_LOGO from "./../assets/images/logo/dathongbao-bct.webp";

import VN_FLAG from "assets/images/flag/vn-flag.png";
import US_FLAG from "assets/images/flag/us-flag.webp";
import AU_FLAG from "assets/images/flag/au-flag.png";
import SING_FLAG from "assets/images/flag/sing-flag.webp";

const NATION_FLAG = {
  VN_FLAG,
  US_FLAG,
  AU_FLAG,
  SING_FLAG,
};

export {
  KHCN_LOGO,
  TRESEMI_LOGO,
  VBC_LOGO,
  VBC_LOGO_DARK,
  BCT_LOGO,
  NATION_FLAG,
};
